import head from 'lodash/head'
import keys from 'lodash/keys'
import round from 'lodash/round'
import findKey from 'lodash/findKey'
import forEach from 'lodash/forEach'
import reduce from 'lodash/reduce'
import map from 'lodash/map'
import startsWith from 'lodash/startsWith'
import { isDesktop } from 'mixins/utilities'

export default {
  methods: {
    iframeResponsiveWrapper (context = []) {
      // Ratio based on the helper classes that Bootstrap 4 provides
      forEach(context, (targetElement) => {
        // Facebook temp fix
        if (startsWith(targetElement.src, 'https://www.facebook.com/plugins/post.php') && !isDesktop()) {
          targetElement.style.marginBottom = '0px'
          targetElement.setAttribute('height', '430')
          return
        }

        const availableRatios = {
          '1by1': 1,
          '4by3': round(4 / 3, 3),
          '16by9': round(16 / 9, 3),
          '21by9': round(21 / 9, 3),
        }

        let iframeWidth = targetElement.getAttribute('width')
        let iframeHeight = targetElement.getAttribute('height')

        if (iframeWidth && iframeHeight) {
          // Trim only numbers
          iframeWidth = head(iframeWidth.match(/[0-9]+/))
          iframeHeight = head(iframeHeight.match(/[0-9]+/))
          const ratio = iframeWidth / iframeHeight

          // Only process landscape ratio
          if (ratio >= 1 && !targetElement.classList.contains('embed-responsive-item')) {
            const closest = reduce(map(keys(availableRatios), o => availableRatios[o]), (prev, curr) => (Math.abs(curr - ratio) < Math.abs(prev - ratio) ? curr : prev))
            const ratioClass = findKey(availableRatios, o => o === closest)

            targetElement.classList.add('embed-responsive-item')
            const wrapper = document.createElement('div')
            wrapper.classList.add('embed-responsive', `embed-responsive-${ratioClass}`)
            const parentNode = targetElement.parentNode
            wrapper.appendChild(targetElement)
            parentNode.appendChild(wrapper)
          }
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./components/mixins/iframeResponsiveWrapper.js